module.exports = __webpack_public_path__ + "img/qrcode.a5f90dce.png";